<div id="content" class="allcp-form" ng-controller="FieldProjectController" ng-init="all()">
    <div ng-include="'modules/company/menus/stock_menu.html'"></div>
    <div class="panel-body">
        <div class="table-responsive" ng-if="data.fieldProjects.length > 0">
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead>
                    <tr class="bg-light">
                        <th class="text-center w100">#</th>
                        <th>
                            <a href="#" ng-click="sortType = 'name'; sortReverse = !sortReverse">
                                Proje Adı
                                <span ng-show="sortType == 'name' && !sortReverse" class="fa fa-caret-down"></span>
                                <span ng-show="sortType == 'name' && sortReverse" class="fa fa-caret-up"></span>
                            </a>
                        </th>
                        <th>
                            <a href="#" ng-click="sortType = 'description'; sortReverse = !sortReverse">
                                Açıklama
                                <span ng-show="sortType == 'description' && !sortReverse" class="fa fa-caret-down"></span>
                                <span ng-show="sortType == 'description' && sortReverse" class="fa fa-caret-up"></span>
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-left" ng-repeat="item in data.fieldProjects | filter: data.term | orderBy:sortType:sortReverse">
                        <td class="text-center">
                            <label class="option block mn">
                                <input type="checkbox" name="deleted[]" ng-checked="deleted.indexOf(item.id) > -1" ng-click="toggleSelection(item.id)">
                                <span class="checkbox mn"></span>
                            </label>
                        </td>
                        <td class="clickable-row" ng-click="goTo(item.id)">{{ item.name }}</td>
                        <td class="clickable-row" ng-click="goTo(item.id)">{{ item.description }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table-responsive" ng-if="data.fieldProjects.length == 0">
            <div class="alert alert-default pastel">
                <i class="fa fa-info pr10"></i>
                <strong>
                    Kayıtlı Projeniz bulunamadı! <a href="stok/projeler/yeni">Buraya</a> tıklayarak yeni proje oluşturubilirsiniz.
                </strong>
            </div>
        </div>
    </div>
    <div ng-include="'modules/company/settings/partials/delete.html'"></div>
</div>